
export function register() {
    if ('serviceWorker' in navigator) {
        window.addEventListener('load', async () => {
            try {
                const registration = await navigator.serviceWorker.register(
                    `${process.env.PUBLIC_URL}/service-worker.js`
                );

                // Check for updates immediately
                registration.update();

                registration.addEventListener('updatefound', () => {
                    const newWorker = registration.installing;

                    if (!newWorker) return;

                    newWorker.addEventListener('statechange', () => {
                        if (
                            newWorker.state === 'installed' &&
                            navigator.serviceWorker.controller
                        ) {
                            // New version installed
                            window.location.reload();
                        }
                    });
                });

            } catch (error) {
                console.error('PWA registration failed:', error);
            }
        });
    }
}
